import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import IconInput from '@kurtosys/ksys-app-components/dist/components/base/IconInput';

export default InjectedStyledComponent(IconInput, 'app', ['iconInput']);